import APIURL from "../axios";
import { useQuery } from "react-query";

const Laundry = async (uuid, l_id, lang) => {
  return await APIURL.get(`/${uuid}/laundry/${l_id}`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang: lang,
    },
  });
};
export const ShowLaundry = (uuid, l_id, lang) => {
  return useQuery(["laundry", uuid, l_id, lang], () =>
    Laundry(uuid, l_id, lang)
  );
};

export const createLaundryOrder = async (
  room_uuid,
  laundry_uuid,
  formData,
  lang,
) => {
  return await APIURL.post(
    `/${room_uuid}/laundry/${laundry_uuid}/order`,
    formData,
    {
      headers: {
        lang: lang,
        "Content-Type": "multipart/form-data",
      },
    },
  );
};


const Laundries = async (room_uuid, lang) => {
  return await APIURL.get(`/${room_uuid}/laundries`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang,
    },
  });
};

export const ShowLaundries = (uuid, lang) => {
  return useQuery(["laundries", uuid, lang], () => Laundries(uuid, lang));
};